module.exports = __webpack_public_path__ + "static/media/reject-white.060a3305.svg";